<script lang="ts">
  import netlifyIdentity from 'netlify-identity-widget';

  import {authService} from '$lib/stores/auth';

  // close widget when authd
  $: if ($authService.matches('authd')) {
    netlifyIdentity.close();
  }
</script>
